import React from "react";
import { Tooltip } from "@material-ui/core";

const UserGeneric = ({
  title,
  addtionalClass,
  onRowClick,
  colProps,
  otherInfo,
}) => {
  return (
    <td
      className={`${addtionalClass} ${onRowClick ? "cursor-pointer" : null}`}
      onClick={() => onRowClick && onRowClick(colProps)}
    >
      <Tooltip title={title} placement="bottom-start">
        <span className="multi-wrap-2">{title}</span>
      </Tooltip>
      {otherInfo ? otherInfo : ""}
    </td>
  );
};

export default UserGeneric;
